var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasquetteCoque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_3",
    "data-name": "Calque 3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1605 1039.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#282d53;}.cls-3,.cls-5,.cls-7{stroke:#000;stroke-miterlimit:10;}.cls-4{fill:#1b203d;}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_45);}.cls-6{fill:#171103;}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_45-2);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_59);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_67);}.cls-10{fill:#0e1129;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-274 -483.98)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1657,1291c-2.76-18.8-101-90-289-209-18-118-86-304-175-399S1004,542,971,533s-241-15-379,44S365,858,365,858s-22,35-25,98c-16,31-13,135-7,197,5.8,59.89,68,70,171,87s291,15,291,15,211,184,250,203,157,100,317,47S1662,1325,1657,1291ZM428.35,1109.36c-3.51,0-6.35-9.36-6.35-20.91s2.84-20.9,6.35-20.9,6.35,9.36,6.35,20.9S431.86,1109.36,428.35,1109.36ZM652.5,1162c-9.66,0-17.5-10.3-17.5-23s7.84-23,17.5-23,17.5,10.3,17.5,23S662.16,1162,652.5,1162Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_45",
    x1: 375,
    y1: 704.02,
    x2: 375,
    y2: 605.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c3b12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#7d4a19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f2b246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#faf192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f2b246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#683810"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_45-2",
    x1: 148,
    y1: 649.02,
    x2: 148,
    y2: 559.02,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_59",
    x1: 824.59,
    y1: 483.98,
    x2: 824.59,
    y2: 1256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#282d53",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#252a4f",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1e2243",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#11152e",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e1129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_67",
    x1: 1106.73,
    y1: 569.97,
    x2: 1106.73,
    y2: 1249.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_59"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "casquette coqu\xE9e") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1657,1291c-2.76-18.8-101-90-289-209-18-118-86-304-175-399S1004,542,971,533s-241-15-379,44S365,858,365,858s-22,35-25,98c-16,31-13,135-7,197,5.8,59.89,68,70,171,87s291,15,291,15,211,184,250,203,157,100,317,47S1662,1325,1657,1291ZM428.35,1109.36c-3.51,0-6.35-9.36-6.35-20.91s2.84-20.9,6.35-20.9,6.35,9.36,6.35,20.9S431.86,1109.36,428.35,1109.36ZM652.5,1162c-9.66,0-17.5-10.3-17.5-23s7.84-23,17.5-23,17.5,10.3,17.5,23S662.16,1162,652.5,1162Z",
    transform: "translate(-274 -483.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1038.9,1225.79,1472,1475l407-184-511-266s-1,71-11,85-52,44-52,44Z",
    transform: "translate(-274 -483.98)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 375,
    cy: 654.52,
    rx: 43,
    ry: 49.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 373,
    cy: 654.52,
    rx: 23,
    ry: 28.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 148,
    cy: 604.02,
    rx: 26,
    ry: 45
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 149.35,
    cy: 604.02,
    rx: 11.35,
    ry: 25.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M795,1255s320-20,510-101c0,0,65-52,70-86s-99-410-99-410S998,482,983,484,339,589,339,589l-65,564,120,88,209,15Z",
    transform: "translate(-274 -483.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M859.29,1249.5S873,955,859,828s-18-215-8-258c111-2,362.54,96.42,409.77,208.21S1368,1082,1368,1082s2,48-63,72S1163.58,1217,859.29,1249.5Z",
    transform: "translate(-274 -483.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M807.5,1253.5c-10-4-12.5,1.5-12.5,1.5s211,184,250,203,157,100,317,47c150-49.68,282.4-164.4,294.27-206.57a18.15,18.15,0,0,0,.73-7.43c-26,31-44.5,58.5-154.5,128.5,0,0-128,81-224,84S1160,1496,1107,1471c-11.72-5.53-48.29-21.7-73-39C947,1371.09,807.5,1253.5,807.5,1253.5Z",
    transform: "translate(-274 -483.98)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasquetteCoque);
export default __webpack_public_path__ + "static/media/casquette_coquée.c6ce6a631e4b70a338390de96d995a85.svg";
export { ForwardRef as ReactComponent };